import { gamesManifest } from '../../data/loadData';
import type { BinColor } from '../../data/schemas';

export const BIN_HEX: Record<BinColor, string> = {
  green: gamesManifest.colors.green,
  blue: gamesManifest.colors.blue,
  red: gamesManifest.colors.red,
};
